__turbopack_context__.v({
  "author": "blog-card-module__ahc-qa__author",
  "blogCard": "blog-card-module__ahc-qa__blogCard",
  "blogGrid": "blog-card-module__ahc-qa__blogGrid",
  "component_type": "blog-card-module__ahc-qa__component_type",
  "content": "blog-card-module__ahc-qa__content",
  "copy": "blog-card-module__ahc-qa__copy",
  "copyTop": "blog-card-module__ahc-qa__copyTop",
  "date": "blog-card-module__ahc-qa__date",
  "description": "blog-card-module__ahc-qa__description",
  "imageContainer": "blog-card-module__ahc-qa__imageContainer",
  "imageIcon": "blog-card-module__ahc-qa__imageIcon",
  "imageOverlay": "blog-card-module__ahc-qa__imageOverlay",
  "link": "blog-card-module__ahc-qa__link",
  "linkWrapper": "blog-card-module__ahc-qa__linkWrapper",
  "numberOverlay": "blog-card-module__ahc-qa__numberOverlay",
  "playButtonWrapper": "blog-card-module__ahc-qa__playButtonWrapper",
  "precisionInProduction": "blog-card-module__ahc-qa__precisionInProduction",
  "resourceCarousel": "blog-card-module__ahc-qa__resourceCarousel",
  "resourceList": "blog-card-module__ahc-qa__resourceList",
  "title": "blog-card-module__ahc-qa__title",
  "wide": "blog-card-module__ahc-qa__wide",
});
